import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {
  public url: string;
  public identity;
  public token;
  public sessionActive: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public http: HttpClient
  ) {
    this.url = GLOBAL.url;
   }

   validarCaptcha(token: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.url + 'validate/captcha/' + token, { headers });
   }
}
